import script from "./ChiSiamoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChiSiamoPage.vue?vue&type=script&setup=true&lang=js"

import "./ChiSiamoPage.vue?vue&type=style&index=0&id=357e5f2a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-357e5f2a"]])

export default __exports__